import { LOCATION_INITIALIZED, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

const defaultLanguage = 'de';

export function appBootstrapFactory(translate: TranslateService, injector: Injector): () => Promise<void> {
    return () => factory(translate, injector);
}

async function factory(translate: TranslateService, injector: Injector): Promise<void> {
    await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

    registerLocales();

    addLanguages(translate);
    translate.setDefaultLang('de');
    await lastValueFrom(translate.use(defaultLanguage));
}

function registerLocales(): void {
    registerLocaleData(localeDe, 'de-DE');

    // add new locales here
}

function addLanguages(translate: TranslateService): void {
    const languages = [
        'en',
        defaultLanguage,
        // add new languages here
    ];
    translate.addLangs(languages);
}
